"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var Confirmation_1 = require("../Confirmation");
var Checkbox_1 = require("../../components/Checkbox");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var PaymentsTable = /** @class */ (function (_super) {
    __extends(PaymentsTable, _super);
    function PaymentsTable(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.renderPaymentsTable = function (payments) {
            return payments.results.filter(function (r) { return r.statusCode !== "FAILED"; }).map(function (payment) {
                var isPaymentChargeback = payment.statusCode === 'CHARGEBACK';
                return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: payment.id }), (0, jsx_runtime_1.jsxs)("td", { children: [moment(payment.date).format("Do MMMM YYYY"), (0, jsx_runtime_1.jsx)("br", {}), isPaymentChargeback &&
                                    (0, jsx_runtime_1.jsxs)("span", { className: "text-danger", children: ["(Marked as chargeback on ", moment(payment.chargebackDate).format("DD.MM.YYYY"), ")"] })] }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(payment.amount) }), (0, jsx_runtime_1.jsx)("td", { children: payment.description }), (0, jsx_runtime_1.jsx)("td", { children: payment.invoiceId }), (0, jsx_runtime_1.jsx)("td", { children: _this.renderPaymentMethod(payment) }), (0, jsx_runtime_1.jsx)("td", { children: payment.statusText }), (0, jsx_runtime_1.jsx)("td", { children: payment.transactionReasonCode }), _this.shouldAllowChargeback &&
                            (0, jsx_runtime_1.jsx)("td", { className: "text-center", children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "chargeback_" + payment.id, className: "no-label", name: "chargeback", label: "", disabled: !payment.chargebackEligible, value: isPaymentChargeback, onChanged: function () { return !isPaymentChargeback && _this.setState({
                                        showMarkChargebackModal: true,
                                        paymentId: payment.id
                                    }); } }) })] }, payment.id));
            });
        };
        _this.renderMarkChargebackModal = function () { return ((0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: _this.state.showMarkChargebackModal, hide: function () { return _this.setState({ showMarkChargebackModal: !_this.state.showMarkChargebackModal }); }, confirm: function () { return _this.markPaymentAsChargeback(); }, title: "", children: "Mark payment as chargeback?" })); };
        _this.renderPaymentMethod = function (payment) {
            var creditCardPayment = payment.cardType && payment.cardNumberObfuscated;
            return creditCardPayment ? (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [payment.cardType, " (", payment.cardNumberObfuscated, ")"] }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: payment.method });
        };
        _this.state = {
            showMarkChargebackModal: false
        };
        _this.shouldAllowChargeback = _this.supportPortalTemplates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support"]);
        return _this;
    }
    PaymentsTable.prototype.render = function () {
        if (this.props.loading) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            if (this.props.payments && this.props.payments.count > 0) {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.renderMarkChargebackModal(), (0, jsx_runtime_1.jsx)("div", { className: "row mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "table-responsive panel-border px-4", children: [(0, jsx_runtime_1.jsx)("b", { className: "pl-2", children: "Payments:" }), (0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "Payment Ref:" }), (0, jsx_runtime_1.jsx)("th", { children: "Payment Date:" }), (0, jsx_runtime_1.jsx)("th", { children: "Amount:" }), (0, jsx_runtime_1.jsx)("th", { children: "Description:" }), (0, jsx_runtime_1.jsx)("th", { children: "Invoice For:" }), (0, jsx_runtime_1.jsx)("th", { children: "Payment Method:" }), (0, jsx_runtime_1.jsx)("th", { children: "Payment Status:" }), (0, jsx_runtime_1.jsx)("th", { children: "Failure Reason Code:" }), this.shouldAllowChargeback &&
                                                            (0, jsx_runtime_1.jsx)("th", { children: "Chargeback:" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderPaymentsTable(this.props.payments) })] })] }) })] }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("h3", { className: "panel-border px-4", children: "Payments not found!" });
            }
        }
    };
    PaymentsTable.prototype.markPaymentAsChargeback = function () {
        this.supportPortalService.markPaymentAsChargeback(this.props.customerReferenceNumber, this.state.paymentId).subscribe(function (e) {
            if (e instanceof Error) {
                console.error(e);
            }
            else {
                window.location.reload();
            }
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], PaymentsTable.prototype, "supportPortalService", void 0);
    PaymentsTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PaymentsTable);
    return PaymentsTable;
}(React.Component));
exports.default = PaymentsTable;
//# sourceMappingURL=PaymentsTable.js.map